// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getMilliseconds/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getMilliseconds = convertToFP(fn, 1);
export default getMilliseconds;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getMilliseconds/index.js
// module id = 900
// module chunks = 0